module.exports = __webpack_public_path__ + "img/9.378132e6.png";